define([
    'common/ui/view/svg/shape/ellipse'
], function(
    EllipseShape
    ) {
    var CircleShape = EllipseShape.extend({
        tagName: 'circle',
        initialize: function(params) {
            params.rx = params.r;
            params.ry = params.r;
            CircleShape.__super__.initialize.call(this, params);
            this._r = params.r;
            this._width = this._r * 2;
            this._height = this._r * 2;
        },

        render: function() {
            this.$el.attr('r', this._r);
            return this;
        }
    }, {
        type: 'circle'
    });

    return CircleShape;
});



// WEBPACK FOOTER //
// ./common/ui/view/svg/shape/circle.js